import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';
import { PaymentModule } from '@payment/payment.module';
import { BTaxRoutingModule } from './btax-routing.module';
import { BTaxBillPaidComponent } from './components/data/bill-paid/btax-bill-paid.component';
import { BTaxBillStatusComponent } from './components/data/bill-status/btax-bill-status.component';
import { BTaxOwnerComponent } from './components/data/owner/btax-owner.component';
import { BTaxPaidOnComponent } from './components/data/paid-on/btax-paid-on.component';
import { BTaxPaymentAmountComponent } from './components/data/payment-amount/btax-payment-amount.component';
import { BTaxPaymentStatusComponent } from './components/data/payment-status/btax-payment-status.component';
import { BTaxPayorComponent } from './components/data/payor/btax-payor.component';
import { BTaxReceiptNumberComponent } from './components/data/receipt-number/btax-receipt-number.component';
import { BTaxTaxYearComponent } from './components/data/tax-year/btax-tax-year.component';
import { BusinessResultItemComponent } from './components/result-item/btax-result-item.component';
import { BusinessResultsComponent } from './components/results/btax-lookup-results.component';
import { BTaxAccountPage } from './pages/account/btax-account.component';
import { BTaxAccountActionsComponent } from './pages/account/components/account-actions/btax-account-actions.component';
import { BTaxAccountHistoryComponent } from './pages/account/components/account-history/btax-account-history.component';
import { AccountBalanceComponent } from './components/data/account-balance/account-balance.component';



@NgModule({
    declarations:
    [
        BTaxAccountPage,
        BTaxAccountActionsComponent,
        BTaxAccountHistoryComponent,
        BTaxBillPaidComponent,
        BTaxBillStatusComponent,
        BTaxOwnerComponent,
        BTaxPaidOnComponent,
        BTaxPaymentAmountComponent,
        BTaxPaymentStatusComponent,
        BTaxPayorComponent,
        BTaxReceiptNumberComponent,
        BTaxTaxYearComponent,
        BusinessResultsComponent,
        BusinessResultItemComponent,
        AccountBalanceComponent,
    ],
    imports:
    [
        SharedModule,
        MaterialModule,

        RouterModule,
        PaymentModule,

        BTaxRoutingModule,
    ],
    exports:
    [
        BusinessResultsComponent,
        AccountBalanceComponent,
    ]
})
export class BTaxModule { }
